import React, { Component } from 'react';
import Toggle from 'react-toggle';
import PropTypes from 'prop-types';
import './CustomToggle.scss';
import { TEXT_FIELD_STATUS } from '../../../utils/constants';


class CustomToggle extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    changeHandler: PropTypes.func.isRequired,
    registerField: PropTypes.func,
  }
  static defaultProps = {
    registerField: () => {},
  }
  componentDidMount() {
    const { registerField, name } = this.props;
    registerField({ name, validator: () => ({ status: TEXT_FIELD_STATUS.VALID, errorText: '' }) });
  }
  changeHandler = () => {
    const {
      changeHandler, name, value,
    } = this.props;

    changeHandler({ value: !value, name });
  };
  render() {
    const { value } = this.props;
    return (
      <div className="toggle-wrapper">
        <Toggle className="toggle" onChange={this.changeHandler} checked={value} icons={false} />
      </div>
    );
  }
}


export default CustomToggle;



// WEBPACK FOOTER //
// ./src/components/_molecules/CustomToggle/CustomToggle.js